import { render } from "./HighHeader.vue?vue&type=template&id=3cc60ae5&scoped=true"
import script from "./HighHeader.vue?vue&type=script&lang=js"
export * from "./HighHeader.vue?vue&type=script&lang=js"

import "./HighHeader.vue?vue&type=style&index=0&id=3cc60ae5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cc60ae5"]])

export default __exports__